import cn from 'classnames';
import { useNavigate } from 'hooks/routes';
import { useHeaderSticky } from 'hooks/common';
import { ArrowLeftIcon_24, LogoIcon } from 'assets/icons';
import Label, { LabelType } from 'components/Label/Label';
import styles from './Header.module.css';

type HeaderProps = {
  title: string;
  label?: LabelType;
  complexComponent?: boolean;
  showArrow?: boolean;
  children?: React.ReactNode;
  contentClassName?: string;
  navigateTo?: VoidFunction;
};

const Header = ({
  title,
  label,
  children,
  complexComponent,
  showArrow = true,
  contentClassName,
  navigateTo,
}: HeaderProps): JSX.Element => {
  const { toBack } = useNavigate();
  const isSticky = useHeaderSticky();

  return (
    <header
      className={cn(styles.container, {
        [styles.sticky]: isSticky,
      })}
    >
      <div className={styles.title__wrapper}>
        <LogoIcon className={styles.logo} />
        {!complexComponent ? (
          <h3 className={styles.title}>{title}</h3>
        ) : (
          <div className={styles.complex}>
            {showArrow && (
              <>
                <ArrowLeftIcon_24
                  className={styles.arrowIcon}
                  onClick={navigateTo ? navigateTo : toBack}
                />
                <div className={styles.verticalDivider} />
              </>
            )}
            <h3 className={styles.complex__title}>{title}</h3>
            {label?.status && <Label label={label} />}
          </div>
        )}
      </div>
      {children && <div className={cn(styles.buttons, contentClassName)}>{children}</div>}
    </header>
  );
};

export default Header;
